import Vue from "vue";

Vue.filter("dateFormat", function(value) {
    return _dateFormat(value);
});

Vue.filter("datetimeFormat", function(value) {
    return _datetimeFormat(value);
});
